import React from 'react';

export const Loader = (...props) => {
  const loaderStyle = {
    border: '2px solid #f3f3f3',
    borderTop: '2px solid #3498db',
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    animation: 'spin 1s linear infinite',
    // margin: '10px auto',
  };

  return (
    <>
      <div style={loaderStyle} {...props}></div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </>
  );
};

